import React, { memo, useCallback } from "react";

import NumberCard from "./NumberCard";
import styles from "./index.module.scss";
import { ISinglePin } from "src/shared/types";
import { TabNames } from "src/shared/config";

interface IScrollerProps {
  charts: ISinglePin[];
  showDetails(id: number, name: string): void;
  selectedTab: typeof TabNames[number];
}

const NumberScroller = (props: IScrollerProps) => {
  const { charts } = props;
  const safeCharts = Array.isArray(charts) ? charts : [];

  const handleScroll = useCallback((e) => {
    // prevents tab swipe
    e.stopPropagation();
  }, []);

  return (
    <div className={styles["horizontal-scroller"]} onTouchMove={handleScroll}>
      {safeCharts.map((element) => (
        <NumberCard
          key={`${element.label}-${element.id}`}
          header={element.label}
          chartData={element}
          showDetails={props.showDetails}
          selectedTab={props.selectedTab}
        />
      ))}
    </div>
  );
};
// NumberScroller.whyDidYouRender = true;
export default memo(NumberScroller);
